import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTA() {
  return <section className="bg-sage py-12 md:py-24 px-4 text-center text-cream-white" data-id="element-183">
      <div className="max-w-6xl mx-auto" data-id="element-184">
        <p className="text-cream-white font-sans font-medium mb-8" data-id="element-185">
          ⏰ El precio cierra en:
        </p>

        <div className="mb-12" data-id="element-186">
          <CountdownTimer variant="final" data-id="element-187" />
        </div>

        <h2 className="font-display italic text-cream-white text-3xl mb-16" data-id="element-188">
          La próxima noche difícil
          <br data-id="element-189" />
          puede ser diferente.
        </h2>

        <div className="grid md:grid-cols-2 gap-8 items-stretch mb-20" data-id="element-190">
          {/* Card 1 */}
          <div className="bg-white/10 border border-cream-white/20 p-10 rounded-2xl text-left" data-id="element-191">
            <p className="text-gold font-sans font-bold text-sm mb-4 uppercase" data-id="element-192">
              💛 COLECCIÓN COMPLETA MENTE EN SILENCIO™
            </p>
            <p className="text-cream-white/70 font-sans text-sm mb-8" data-id="element-193">
              Manual 30 módulos + 3 Bonos · 200+ páginas
            </p>

            <div className="mb-8" data-id="element-194">
              <p className="text-cream-white/40 line-through text-lg mb-1" data-id="element-195">
                $47.000
              </p>
              <p className="font-display font-bold text-cream-white text-[40px]" data-id="element-196">
                $19.990 ARS
              </p>
            </div>

            <motion.a href="https://checkout2.guiadigital360.online/cart/44370674221149:1" animate={{
            scale: [1, 1.03, 1]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} whileHover={{
            scale: 1.05,
            backgroundColor: '#2D4033'
          }} whileTap={{
            scale: 0.98
          }} className="bg-sage text-cream-white border border-cream-white/30 font-sans font-bold py-[18px] px-[40px] rounded-[50px] text-center block" data-id="element-197">
              → QUIERO MI COLECCIÓN AHORA
            </motion.a>
          </div>

          {/* Card 2 */}
          <div className="bg-gold/15 border-2 border-gold p-8 md:p-10 rounded-2xl text-left flex flex-col" data-id="element-198">
            <p className="text-gold font-sans font-bold text-sm mb-4 uppercase" data-id="element-199">
              ⭐ MÁS COMPLETO
            </p>
            <p className="text-gold font-display font-bold text-xl mb-4" data-id="element-200">
              💛 COLECCIÓN + PROTOCOLO AVANZADO 90 DÍAS
            </p>
            <p className="text-cream-white/70 font-sans text-sm mb-8" data-id="element-201">
              Manual + 3 Bonos + Sistema de Reprogramación Nerviosa
            </p>

            <ul className="space-y-3 mb-12" data-id="element-202">
              {['60+ páginas del Protocolo Avanzado', '4 Pilares de transformación profunda', 'Trackers mensuales × 3 meses', 'Protocolos para crisis de vida real', 'Biblioteca de 20 bloqueos con solución'].map((item, i) => <li key={i} className="flex items-center gap-3 text-cream-white font-sans text-sm" data-id="element-203">
                  <span className="text-gold" data-id="element-204">✓</span> {item}
                </li>)}
            </ul>

            <div className="mb-8" data-id="element-205">
              <p className="text-cream-white/40 line-through text-lg mb-1" data-id="element-206">
                $69.000
              </p>
              <p className="font-display font-bold text-gold text-[52px]" data-id="element-207">
                $24.990 ARS
              </p>
            </div>

            <motion.a href="https://checkout2.guiadigital360.online/cart/44370707284061:1" animate={{
            scale: [1, 1.03, 1]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} whileHover={{
            scale: 1.05,
            backgroundColor: '#C4956A'
          }} whileTap={{
            scale: 0.98
          }} className="bg-gold text-sage-dark font-sans font-bold py-[18px] px-[40px] rounded-[50px] text-center block" data-id="element-208">
              → QUIERO LA COLECCIÓN COMPLETA
            </motion.a>

            <p className="text-terracotta font-sans font-medium text-sm mt-6 text-center" data-id="element-209">
              ⚠️ Después sube $8.000 ARS. No vuelve.
            </p>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-8 text-cream-white/70 font-sans font-light text-sm" data-id="element-210">
          <span data-id="element-211">🔒 Pago 100% Seguro</span>
          <span data-id="element-212">🛡️ Garantía de Satisfacción</span>
          <span data-id="element-213">⚡ Acceso Instantáneo</span>
        </div>
      </div>
    </section>;
}